var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#CFE2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_502_14161",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 22,
    height: 22
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.3335,
    y: 9.33301,
    width: 21.3333,
    height: 21.3333,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_502_14161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 19.9998C19.0225 19.9998 18.1855 19.6516 17.4892 18.9553C16.7929 18.259 16.4447 17.422 16.4447 16.4442C16.4447 15.4664 16.7929 14.6294 17.4892 13.9331C18.1855 13.2368 19.0225 12.8887 20.0003 12.8887C20.978 12.8887 21.8151 13.2368 22.5114 13.9331C23.2077 14.6294 23.5558 15.4664 23.5558 16.4442C23.5558 17.422 23.2077 18.259 22.5114 18.9553C21.8151 19.6516 20.978 19.9998 20.0003 19.9998ZM12.8892 25.3331V24.622C12.8892 24.1183 13.0188 23.6553 13.278 23.2331C13.5373 22.8109 13.8818 22.4887 14.3114 22.2664C15.2299 21.8072 16.1632 21.4627 17.1114 21.2331C18.0595 21.0035 19.0225 20.8887 20.0003 20.8887C20.978 20.8887 21.941 21.0035 22.8892 21.2331C23.8373 21.4627 24.7706 21.8072 25.6892 22.2664C26.1188 22.4887 26.4632 22.8109 26.7225 23.2331C26.9818 23.6553 27.1114 24.1183 27.1114 24.622V25.3331C27.1114 25.822 26.9373 26.2405 26.5892 26.5887C26.241 26.9368 25.8225 27.1109 25.3336 27.1109H14.6669C14.178 27.1109 13.7595 26.9368 13.4114 26.5887C13.0632 26.2405 12.8892 25.822 12.8892 25.3331ZM14.6669 25.3331H25.3336V24.622C25.3336 24.459 25.2929 24.3109 25.2114 24.1776C25.1299 24.0442 25.0225 23.9405 24.8892 23.8664C24.0892 23.4664 23.2818 23.1664 22.4669 22.9664C21.6521 22.7664 20.8299 22.6664 20.0003 22.6664C19.1706 22.6664 18.3484 22.7664 17.5336 22.9664C16.7188 23.1664 15.9114 23.4664 15.1114 23.8664C14.978 23.9405 14.8706 24.0442 14.7892 24.1776C14.7077 24.3109 14.6669 24.459 14.6669 24.622V25.3331ZM20.0003 18.222C20.4892 18.222 20.9077 18.0479 21.2558 17.6998C21.604 17.3516 21.778 16.9331 21.778 16.4442C21.778 15.9553 21.604 15.5368 21.2558 15.1887C20.9077 14.8405 20.4892 14.6664 20.0003 14.6664C19.5114 14.6664 19.0929 14.8405 18.7447 15.1887C18.3966 15.5368 18.2225 15.9553 18.2225 16.4442C18.2225 16.9331 18.3966 17.3516 18.7447 17.6998C19.0929 18.0479 19.5114 18.222 20.0003 18.222Z",
    fill: "#6C757D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.8e52ddf1212ae08a7f8dfdfae9136e4b.svg";
export { ForwardRef as ReactComponent };